import React from "react";
import "./guest-reviews.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { BiChevronRightCircle } from "react-icons/bi";

const GuestReviews = () => {
  return (
    <>
      <div className="guest-reviews-section" id="guest-content">
        <div className="heading">
          <h2>Guest Reviews</h2>
        </div>
        <div className="row gap-3">
          <div className="col-12">
            <div className="row justify-content-between">
              <div className="col-lg-3">
                <div className="rating-box">
                  <div className="rating-score">
                    <span className="score-box">
                      8.9 <span> /10</span>{" "}
                    </span>
                    <small> 11 reviews</small>
                  </div>
                  <p>
                    Verified Reviews{" "}
                    <img src="/images/icons/help-icon.svg" alt="icon" />
                  </p>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="review-bars">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="review-item">
                        <div className="progress-label">
                          <p>Cleanliness</p>
                          <span>8</span>
                        </div>
                        <div className="progress">
                          <div
                            className="average-icon"
                            style={{ width: "83%" }}
                          >
                            <img
                              src="/images/icons/progress-locator.svg"
                              alt="average"
                            />
                          </div>
                          <div
                            className="progress-bar"
                            style={{ width: "80%" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="review-item">
                        <div className="progress-label">
                          <p>Amenities</p>
                          <span>7.4</span>
                        </div>
                        <div className="progress">
                          <div
                            className="average-icon"
                            style={{ width: "93%" }}
                          >
                            <img
                              src="/images/icons/progress-locator.svg"
                              alt="average"
                            />
                          </div>
                          <div
                            className="progress-bar"
                            style={{ width: "74%" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="review-item">
                        <div className="progress-label">
                          <p>Location</p>
                          <span>7.5</span>
                        </div>
                        <div className="progress">
                          <div
                            className="average-icon"
                            style={{ width: "83%" }}
                          >
                            <img
                              src="/images/icons/progress-locator.svg"
                              alt="average"
                            />
                          </div>
                          <div
                            className="progress-bar"
                            style={{ width: "75%" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="review-item">
                        <div className="progress-label">
                          <p>Service</p>
                          <span>7</span>
                        </div>
                        <div className="progress">
                          <div
                            className="average-icon"
                            style={{ width: "73%" }}
                          >
                            <img
                              src="/images/icons/progress-locator.svg"
                              alt="average"
                            />
                          </div>
                          <div
                            className="progress-bar"
                            style={{ width: "70%" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="note">
                    {" "}
                    <img
                      src="/images/icons/progress-locator.svg"
                      alt="average"
                    />{" "}
                    Average for similar properties in Islamabad
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="book-now">
              Book now and leave a review after your stay to earn up to{" "}
              <span>120 Trip Coins </span> (approx. <span>Rs 340.03</span>).
              Trip Coins can be used to save instantly on room rates.
            </div>
          </div>
          <div className="col-12">
            <div className="heading">
              <h2>Most Mentioned</h2>
            </div>
            <ul className="includings">
              <li>All reviews (11)</li>
              <li>Positive reviews (11)</li>
              <li>Reviews with photos/video (3)</li>
            </ul>
          </div>
          <div className="col-12">
            <div className="heading">
              <h2>Guest Impressions</h2>
            </div>
            <div className="guest-impression-slider">
              <Swiper
                spaceBetween={16}
                slidesPerView={1}
                breakpoints={{
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                }}
                navigation={true}
              >
                <SwiperSlide>
                  <div className="guest-review-card">
                    <div className="profile-wrap">
                      <img src="/images/icons/user.svg" alt="user" />
                      <div>
                        <h6>amran Fazal</h6>
                        <p>May 16, 2025</p>
                      </div>
                    </div>
                    <p className="msg">nothing more special</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="guest-review-card">
                    <div className="profile-wrap">
                      <img src="/images/icons/user.svg" alt="user" />
                      <div>
                        <h6>‍a‍u‍l‍_‍G‍e‍o‍F‍I‍R‍E</h6>
                        <p>May 9, 2025</p>
                      </div>
                    </div>
                    <p className="msg">
                      I booked this accommodation many months in advance for my
                      trip. Sunny (the hotel owner) is friendly and responsive.
                      He offered to arrange the travel paperwork, airport
                      transfer, and provided general advice relating to Pakistan
                      and Islamabad. I…
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="guest-review-card">
                    <div className="profile-wrap">
                      <img src="/images/icons/user.svg" alt="user" />
                      <div>
                        <h6>
                          ‍h‍i‍g‍u‍a‍n‍g‍b‍u‍l‍a‍o‍，‍y‍i‍q‍i‍e‍d‍o‍u‍h‍a‍o
                        </h6>
                        <p>November 10, 2023</p>
                      </div>
                    </div>
                    <p className="msg">
                      The boss is very nice and enthusiastic! It will also give
                      you more choices based on your financial situation. To be
                      honest, although it is not as magnificent as a luxurious
                      star hotel, I feel like I am …
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="guest-review-card">
                    <div className="profile-wrap">
                      <img src="/images/icons/user.svg" alt="user" />
                      <div>
                        <h6>amran Fazal</h6>
                        <p>May 16, 2025</p>
                      </div>
                    </div>
                    <p className="msg">nothing more special</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="guest-review-card">
                    <div className="profile-wrap">
                      <img src="/images/icons/user.svg" alt="user" />
                      <div>
                        <h6>‍a‍u‍l‍_‍G‍e‍o‍F‍I‍R‍E</h6>
                        <p>May 9, 2025</p>
                      </div>
                    </div>
                    <p className="msg">
                      I booked this accommodation many months in advance for my
                      trip. Sunny (the hotel owner) is friendly and responsive.
                      He offered to arrange the travel paperwork, airport
                      transfer, and provided general advice relating to Pakistan
                      and Islamabad. I…
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="guest-review-card">
                    <div className="profile-wrap">
                      <img src="/images/icons/user.svg" alt="user" />
                      <div>
                        <h6>
                          ‍h‍i‍g‍u‍a‍n‍g‍b‍u‍l‍a‍o‍，‍y‍i‍q‍i‍e‍d‍o‍u‍h‍a‍o
                        </h6>
                        <p>November 10, 2023</p>
                      </div>
                    </div>
                    <p className="msg">
                      The boss is very nice and enthusiastic! It will also give
                      you more choices based on your financial situation. To be
                      honest, although it is not as magnificent as a luxurious
                      star hotel, I feel like I am …
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
            <Link to="" className="show-more">
              Show More <BiChevronRightCircle />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuestReviews;
